import { FC, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import Image from 'next/image';
import { AnimatePresence, motion } from 'framer-motion';
import SwiperCore from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
import { ActiveImage, Container, PreviewImage, PreviewWrapper, SlideArrow } from './Packshot.style';
interface Props {
  data: string[];
}
const ProductPackshot: FC<Props> = ({
  data
}: Props) => {
  SwiperCore.use([Navigation, Pagination]);
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [isSlideEnd, setIsSlideEnd] = useState(false);
  const [isSlideStart, setIsSlideStart] = useState(true);
  const slideArrowMotionVariants = {
    enabled: {
      opacity: 0.4
    },
    disabled: {
      opacity: 0.2
    }
  };
  const onSlideChange = (swiper: SwiperCore) => {
    setIsSlideStart(swiper.isBeginning);
    setIsSlideEnd(swiper.isEnd);
  };
  return <Container>
            <ActiveImage>
                <AnimatePresence>
                    <motion.img key={activeImageIndex} src={data[activeImageIndex] || '/images/default/product.jpg'} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} alt="Product Image" onError={({
          currentTarget
        }) => {
          currentTarget.onerror = null; // prevents looping
          currentTarget.src = '/images/default/product.jpg';
        }} />
                </AnimatePresence>
            </ActiveImage>
            <PreviewWrapper>
                <Swiper slidesPerView={5} spaceBetween={8} navigation={{
        prevEl: navigationPrevRef.current,
        nextEl: navigationNextRef.current
      }} onBeforeInit={swiper => {
        // @ts-ignore
        // eslint-disable-next-line no-param-reassign
        swiper.params.navigation.prevEl = navigationPrevRef.current;
        // @ts-ignore
        // eslint-disable-next-line no-param-reassign
        swiper.params.navigation.nextEl = navigationNextRef.current;
      }} onSlideChange={swiper => onSlideChange(swiper)}>
                    {data?.map((imageUrl, index) => <SwiperSlide key={index}>
                            <PreviewImage className={index === activeImageIndex && 'active'} onClick={() => setActiveImageIndex(index)}>
                                <Image src={imageUrl || '/images/default/product.jpg'} alt="Product Image" onError={({
              currentTarget
            }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = '/images/default/product.jpg';
            }} placeholder="blur" blurDataURL="/images/default/product.jpg" width={100} height={100} />
                            </PreviewImage>
                        </SwiperSlide>)}
                </Swiper>
                <SlideArrow ref={navigationPrevRef} className="arrow-left" animate={isSlideStart ? 'disabled' : 'enabled'} variants={slideArrowMotionVariants}>
                    <Image src="/icons/angle-left.svg" alt="slide-arrow" width={24} height={24} />
                </SlideArrow>
                <SlideArrow ref={navigationNextRef} className="arrow-right" animate={isSlideEnd ? 'disabled' : 'enabled'} variants={slideArrowMotionVariants}>
                    <Image src="/icons/angle-right.svg" alt="slide-arrow" width={24} height={24} />
                </SlideArrow>
            </PreviewWrapper>
        </Container>;
};
export default ProductPackshot;